module.exports = __webpack_public_path__ + "_/resources/images/corner.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/corner.svg
// module id = 534
// module chunks = 0